module.exports = __webpack_public_path__ + "img/instagram-white.63a59d00.png";